module.exports = __webpack_public_path__ + "img/icon-push-notification.b4cc549d.svg";